import { render, staticRenderFns } from "./TRegBasic.vue?vue&type=template&id=7a0072ba&scoped=true"
import script from "./TRegBasic.vue?vue&type=script&lang=js"
export * from "./TRegBasic.vue?vue&type=script&lang=js"
import style0 from "./TRegBasic.vue?vue&type=style&index=0&id=7a0072ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0072ba",
  null
  
)

export default component.exports